import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LoaderComponent } from '@shared/components/loader/loader.component';
import { TranslationPipe } from '@shared/pipes/translation.pipe';
import { NotificationService } from '@services/notification.service';
import { ClientService } from '@services/client.service';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { SessionService } from '@services/session.service';
import { take } from 'rxjs';

@Component({
  selector: 'app-add-client-dialog',
  templateUrl: './add-client-dialog.component.html',
  styleUrls: ['./add-client-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    TranslationPipe,
    FormsModule,
    AsyncPipe,
    LoaderComponent,
  ],
})
export class AddClientDialogComponent {
  private readonly clientService = inject(ClientService);
  private readonly session = inject(SessionService);
  private readonly notificationService = inject(NotificationService);
  private readonly dialogRef =
    inject<MatDialogRef<AddClientDialogComponent>>(MatDialogRef);

  name = '';
  isLoading$ = this.clientService.isLoading$;

  constructor() {}

  addClient() {
    this.clientService
      .addClient(this.name)
      .pipe(take(1))
      .subscribe({
        next: (client) => {
          this.session.changeClient(client);
          this.notificationService.showNotification('Client added');
          this.dialogRef.close(true);
        },
        error: () =>
          this.notificationService.showNotification('Error adding client'),
      });
  }
}
